import { createAsyncThunk } from "@reduxjs/toolkit";

import { getSelectedLayout } from "@/models/layout/layout.model";
import { AppState } from "@/redux/store/store";
import { fetchAuthToken } from "@/helpers/fetch-auth-token";

export const fetchSelectedLayout = createAsyncThunk(
  "layout/fetchSelectedLayout",
  async (
    params: Partial<{ config: object }>,
    { getState, rejectWithValue }
  ) => {
    try {
      const { config } = params;
      const { adapter } = getState() as AppState;
      const { baseUrl } = adapter.adapter;
      const { token } = fetchAuthToken(getState());

      return await getSelectedLayout(token, baseUrl, config);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
